import { PreloadReceiptImagesController as controller } from './preload-receipt-images.controller'
import template from './preload-receipt-images.html'

/**
 * Preload receipt images. Achieved by adding the receipt header and footer html to the DOM. This includes the main
 * 'banner' image in addition to any images added by the retailer in the header / footer WYSIWYG.
 *
 * @type {component}
 */
export const PreloadReceiptImagesComponent = {
  controller,
  template,
}
